module.exports = __webpack_public_path__ + "media/images/clearco-glyph-8c9c46236fadb86dd2d2572f5680e472.png";